export const EMUDLList: any[] = [
  {
    deviceName: 'EMS-6407',
    payload: null
  },
  {
    deviceName: 'EMS-6506',
    payload: null
  },
  {
    deviceName: 'EMS-6518',
    payload: null
  },
  {
    deviceName: 'EMS-6552',
    payload: null
  }
]